// Public writer for AI-assistant referrals: a human landing on the site from
// ChatGPT / Perplexity / Copilot / Gemini / Claude. These are the visits that
// prove an assistant cited us, and the landing page tells us what it cited.
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const Input = z.object({
  assistant: z.string().min(1).max(40),
  referrer: z.string().max(500).optional().nullable(),
  path: z.string().min(1).max(500),
  query: z.string().max(500).optional().nullable(),
  question: z.string().max(300).optional().nullable(),
  anonymousId: z.string().max(64).optional().nullable(),
  userAgent: z.string().max(400).optional().nullable(),
});

export const recordAiReferralVisit = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => Input.parse(data))
  .handler(async ({ data }) => {
    try {
      const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
      await supabaseAdmin.from("ai_referral_visits" as never).insert({
        assistant: data.assistant,
        referrer: data.referrer ?? null,
        path: data.path,
        query: data.query ?? null,
        question: data.question ?? null,
        anonymous_id: data.anonymousId ?? null,
        user_agent: data.userAgent ?? null,
      } as never);
    } catch {
      // Telemetry only.
    }
    return { ok: true as const };
  });
